import { useEffect, useState } from 'react'
import ReportsApi from '../api/ReportsAPI';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import ReportTypes from '../enums/ReportTypes';
import { IUseDocumentGenerationProps, ReportType } from '../Models/IUseDocumentGenerationProps';
import { notification } from 'antd';


const useDocumentGeneration = (props: IUseDocumentGenerationProps) => {
    const {selectedInvestors, language} = props;
    const [documentLoading, setDocumentLoading] = useState<boolean>(false)
	const [selectedDate, setSelectedDate] = useState<string>(dayjs().format('DD/MM/YYYY'))
	const [capitalCallDates, setCapitalCallDates] = useState<string[]>([])
	const [distributionDates, setDistributionDates] = useState<string[]>([])
    const [reportTypeSelected, setReportTypeSelected] = useState<ReportType>(ReportTypes[0])
	const [searchParams, _] = useSearchParams();

	useEffect(() => {
		if(selectedInvestors?.idVehicle !== 0 && selectedInvestors?.investors.length > 0) {
			getCapitalCallDates(selectedInvestors);
			getDistributionDates(selectedInvestors)
		}
		if(reportTypeSelected.IdReport !== 4) {
			setSelectedDate('')
		}
	}, [selectedInvestors.idVehicle, selectedInvestors.investors])

	useEffect(() => {
		if(searchParams.has('report')) {
			let location  = window.location;
			let params = searchParams.toString().replace('report=true&', '');
			window.open( location.origin + `/Report/?${params}`, '_blank')
		}
	}
	, [searchParams])

 	const handleChangeReport = (e: number) => {
		let report: ReportType = ReportTypes.find((x: ReportType) => x.IdReport === e) || ReportTypes[0];
		setReportTypeSelected(report);
		if(report && report?.IdReport === 4) {
			setSelectedDate(dayjs().format('DD/MM/YYYY'))
		}else{
			setSelectedDate('')
		}
	};

	const viewReport = async(reportType: string, date: string = selectedDate, investors: number[] = selectedInvestors.investors) => {
		setDocumentLoading(true)
		switch(reportType) {
			case "CapitalCalls":
				await viewCapitalCall(date, investors);
				break;
			case "Distribution":
				await viewDistribution(date, investors);
				break;
			case "Closing":
				await viewClosing(investors);
				break;
			case "CapitalAccount":
				await viewCapitalAccount(date, investors);
				break;
		}
	}

	const getCapitalCallDates = async(data: any) => {
		await ReportsApi.GetCapitalCallDates(data).then((res: any)=>{
			if(res.success){
				setCapitalCallDates(res.data)
			}else{
				console.log(res.errorMessage)
			}
		});
		setDocumentLoading(false)
	}

	const getDistributionDates = async(data: any) => {
		await ReportsApi.GetDistributionDates(data).then((res: any)=>{
			if(res.success){
				setDistributionDates(res.data)
			}else{
				console.log(res.errorMessage)
			}
		});
		setDocumentLoading(false)
	}

	const viewCapitalCall = async(date: string, investors: number[]) => {
		investors.forEach(async (investorId: number) => {
			let formatedDate = dayjs(date, 'YYYY/MM/DD').format('YYYY-MM-DD')
			window.open(`${window.location.origin}/Report/?type=capital-call&date=${formatedDate}&investor=${investorId}&lang=${language}`, '_blank')
		});
		setDocumentLoading(false)
	}

	const viewCapitalAccount = async(date: string, investors: number[]) => {
		let formatedDate = dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
		investors.forEach(async (investor) => {
			let url = `${window.location.origin}/Report/?type=capital-account&date=${formatedDate}&investor=${investor}`
			window.open(url, '_blank')
		})
		setDocumentLoading(false)
	}

	const viewDistribution = async(date: string, investors: number[]) => {
		investors.forEach(async (investorId: number) => {
			let formatedDate = dayjs(date, 'YYYY/MM/DD').format('YYYY-MM-DD')
			window.open(`${window.location.origin}/Report/?type=distribution&date=${formatedDate}&investor=${investorId}&lang=${language}`, '_blank')
		});
		setDocumentLoading(false)
	}
	const viewClosing = async(investors: number[]) => {
		for (let i = 0; i < investors.length; i++) {			
			await ReportsApi.GenerateClosing(investors[i]).then(res=>{
				if(res?.data){
					window.open(res?.data, '_blank');
				}else{
					notification.error({
						message: 'Error',
						description: 'Report could not be generated'
					})
					
				}
			}).catch((e: any) => {
				setDocumentLoading(false)
			})
			await new Promise(resolve => setTimeout(resolve, 1000)); // Espera 1 segundo antes de la siguiente apertura
		}
		setDocumentLoading(false)

	}

  return {
    viewReport,
	selectedDate,
	documentLoading,
	setSelectedDate,
	handleChangeReport,
	reportTypeSelected,
	capitalCallDates,
    distributionDates,
  }
}

export default useDocumentGeneration